<template>
  <!-- <div class="principal-menu-navegacion" v-if="!this.$store.getters.onboardingOnProgress"> -->
    <div class="principal-menu-navegacion" :style="{ display: $store.getters.onboardingOnProgress ? 'none' : 'block' }">
    <nav class="navbar nav-masters">
      <button
        class="navbar-toggler boton-abre-menu p-4"
        type="button"
        @click.prevent="MostrarMenuMovil()"
      >
        <i
          style="color: #b8725a;"
          class="fas fa-bars fa-lg icono-hamburguesa"
        ></i>
      </button>
      <div class="offset-1 nav-masters__offset"></div>
      <div class="nav-masters__logo">
        <img
          src="../../../../public/img/images/logo-emb.png"
          class="logo-embajadores"
        />
      </div>
      <div class="nav-masters__usuario">
        <div class="nav-masters__usuario-auxiliar">
          <label class="nav-masters__usuario-nombre">{{
            this.NombreCompletoUsuario
          }}</label>
          <i class="fas fa-user-tie nav-masters__usuario-icono"></i>
        </div>
        <div class="nav-masters__usuario-opciones">
          <label
            class="nav-masters__usuario-opcion"
            @click.prevent="CerrarSesion()"
          >
            {{
              TipoPersona == 2 || TipoPersona == 5 || TipoPersona == 7
                ? "Logout"
                : "Cerrar sesión"
            }}
          </label>
        </div>
      </div>
    </nav>
    <div class="borde-bronce"></div>
    <div class="menu-escritorio">
      <ul class="list-group list-group-horizontal lista-menu-escritorio">
        <li
          class="list-group-item opcion-menu-escritorio"
          v-if="TipoUsuario == 1 || TipoUsuario == 6 || TipoUsuario == 9"
          @click.prevent="$router.push({ name: 'Calendario' })"
        >
          Calendario
        </li>
        <li
          class="list-group-item opcion-menu-escritorio"
          v-if="
            TipoUsuario == 1 ||            
              TipoUsuario == 4 ||
              TipoUsuario == 5 ||
              TipoUsuario == 6 ||
              TipoUsuario == 8 ||
              TipoUsuario == 9 || 
              TipoUsuario == 10
          "
          @click.prevent="IrAProspectos"
        >
          Prospectos
        </li>
        <li
          class="list-group-item opcion-menu-escritorio"
          v-if="TipoUsuario == 5 || TipoUsuario == 6 || TipoUsuario == 8 || TipoUsuario == 9 || TipoUsuario == 10"
          @click.prevent="$router.push({ path: 'AdministracionDeClientes' })"
        >
          Clientes
        </li>
         <li
          class="list-group-item opcion-menu-escritorio"
          v-if="TipoUsuario == 4 || TipoUsuario == 5 || TipoUsuario == 6 || TipoUsuario == 8 || TipoUsuario == 9 || TipoUsuario == 10"
          @click.prevent="$router.push({ path: 'AdministracionDePendientes' })"
        >
          Pausados / Cancelados
        </li>
        <li
          class="list-group-item opcion-menu-escritorio"
          v-if="
            TipoUsuario == 1 ||
              TipoUsuario == 4 ||
              TipoUsuario == 5 ||
              TipoUsuario == 6 ||
              TipoUsuario == 8 ||
              TipoUsuario == 9 ||
              TipoUsuario == 10 ||
              TipoUsuario == 11
          "
          @click.prevent="$router.push({ name: 'BibliotecaDigital' })"
        >
          Biblioteca Virtual
        </li>
        <li
          class="list-group-item opcion-menu-escritorio"
          v-if=" TipoUsuario == 11
          "
          @click.prevent="$router.push({ name: 'AdministracionBibliotecaDigital' })"
        >
          Administrador Biblioteca Virtual
        </li>
        <li
          class="list-group-item opcion-menu-escritorio"
          v-if="
              (TipoUsuario == 3 &&
              $store.getters.avisoPrivacidadAceptado)
          "
          @click.prevent="$router.push({ name: 'CajaDorada' })"
        >
          {{ (TipoPersona == 2 || TipoPersona == 5 || TipoPersona == 7) ? "Welcome Kit" : "Kit de Bienvenida" }}
        </li>
        <li
          class="list-group-item opcion-menu-escritorio"
          v-if="TipoUsuario == 3 && $store.getters.avisoPrivacidadAceptado" 
          @click.prevent="IrAProspectos"
        >
          {{ (TipoPersona == 2 || TipoPersona == 5 || TipoPersona == 7) ? "Tracking" : "Seguimiento" }}
        </li>
        <li
          class="list-group-item opcion-menu-escritorio"
          v-if="TipoUsuario == 1 || TipoUsuario == 6 || TipoUsuario == 7 || TipoUsuario == 8 || TipoUsuario == 9 || TipoUsuario == 10"
          @click.prevent="$router.push({ name: 'Dashboard2' })"
        >
          Dashboard
        </li>
        <li
          class="list-group-item opcion-menu-escritorio"
          v-if="TipoUsuario == 11"
          @click.prevent="$router.push({ name: 'Administrador' })"
        >
          Perfiles
        </li>
        <li
          class="list-group-item opcion-menu-escritorio"
          v-if="TipoUsuario == 10"
          @click.prevent="$router.push({ name: 'AdministradorComercial' })"
        >
          Perfiles
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="js">
import servicios from '../servicios/service.js';

export default {
  name: "MenuNavegacion",
  data() {
    return {
      TipoUsuario: null,
      TipoPersona: null,
      etapaId: null,
      NombreUsuario: "",
      ApellidoUsuario: "",
      avisoPrivacidadAceptado: false,
    }
  },
  created () {
    this.$root.$refs.MenuNavegacion = this;
  },
  mounted () {
    this.onboardingOnProgress = sessionStorage.getItem('onboarding-on-progress');
    this.ProspectoId = this.$store.getters.prospectoId;
    this.TipoUsuario = parseInt(sessionStorage.getItem("tipoUsuario"));
    this.NombreUsuario = sessionStorage.getItem("nombreUsuario");
    this.ApellidoUsuario = sessionStorage.getItem("apellidoUsuario");
    this.TipoPersona = sessionStorage.getItem("tipoPersona");
     this.etapaId = sessionStorage.getItem("etapaId");
  },
  computed: {
    NombreCompletoUsuario() {
      return this.NombreUsuario + " " + this.ApellidoUsuario;
    }
  },
  methods:{
    MostrarMenuMovil(){
      this.$root.$refs.MenuNavegacionMovil.AbrirMenu();
    },
    IrAProspectos(){
      switch (this.TipoUsuario) {
        case 1: case 4: case 6: case 5: case 8: case 9: case 10:
          if(this.$route.name != "AdministracionDeProspectos")
            this.$router.push({name: "AdministracionDeProspectos"});
          break;
        case 3:
          if(this.$route.name != "SeguimientoProspecto") {
            this.$router.push({
              name: "SeguimientoProspecto",
              params: {
                TipoUsuario: this.TipoUsuario
              },
            })
          }
          break;
        default:
          break;
      }
    },
    CerrarSesion() {
      this.$fire({
        title: (this.TipoPersona == 2 || this.TipoPersona == 5 || this.TipoPersona == 7) ? "Are you sure you want to log out?" : "¿Estás seguro que quieres cerrar sesión?",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: (this.TipoPersona == 2 || this.TipoPersona == 5 || this.TipoPersona == 7) ? "Accept" : "Aceptar",
        cancelButtonText: (this.TipoPersona == 2 || this.TipoPersona == 5 || this.TipoPersona == 7) ? "Cancel" : "Cancelar"
      }).then(result => {
        if (result.value) {
            // if(!this.$store.getters.avisoPrivacidadAceptado)
            //   if(this.ProspectoId != null) this.EstablecerPrimerAccesoProspecto(this.ProspectoId);
            servicios.CerrarSesion();
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.principal-menu-navegacion {
  text-align: center;
  background-size: 100% 5px;
}
.nav-masters {
  display: none;
  background-color: #ffffff;
  padding-bottom: 0;
  display: none;
  padding-top: 0;
  justify-content: space-between;
  align-items: center;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}

.nav-masters__offset {
  width: auto;
}
.nav-masters__logo {
  margin-top: 10px;
  margin-bottom: 10px;
}
.nav-masters__usuario {
  @extend .nav-masters__logo;
  width: auto;
  cursor: pointer;
  height: 40px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-right: 20px;
  justify-content: center;
}
.nav-masters__usuario-auxiliar:hover ~ .nav-masters__usuario-opciones {
  display: block;
}
.nav-masters__usuario-opciones:hover {
  display: block;
}
.nav-masters__usuario-opcion:hover {
  text-decoration: underline;
  cursor: pointer;
  font-weight: bold;
}
.nav-masters__usuario-nombre {
  font-weight: bold;
  cursor: pointer;
  color: #b8725a;
  font-size: 16px;
}
.nav-masters__usuario-icono {
  margin-left: 10px;
  color: #b8725a;
  font-size: 22px;
}
.nav-masters__usuario-opciones {
  @extend .nav-masters__usuario-nombre;
  width: 100%;
  text-align: right;
  display: none;
  list-style: none;
  font-size: 14px;
}

.navbar-brand {
  color: #696158;
}
.borde-bronce {
  height: 6px;
  width: 100%;
  background: linear-gradient(
    90deg,
    #9e6353 0%,
    #a16555 22.05%,
    #a86d5b 31.23%,
    #b57a65 38.02%,
    #ca9076 43.63%,
    #e6ad8d 48.46%,
    #f6be9a 50.49%,
    #eeb590 51.88%,
    #dea47d 55.64%,
    #d39770 60.13%,
    #cd9168 65.98%,
    #cb8f66 78.29%,
    #9e6353 100%
  );
}
.boton-abre-menu {
  border-style: none;
  display: none;
  position: absolute;
  left: 0;
}
.navbar-toggler:focus {
  border: none;
  outline: none;
  box-shadow: none;
}

.icono-hamburguesa {
  color: #969696;
}

.logo-embajadores {
  height: 80px;
  width: 180px;
}

.menu-escritorio {
  width: 100vw;
  background-color: #1e2120;
}
.lista-menu-escritorio {
  padding-left: 10px;
}
.opcion-menu-escritorio {
  background-color: #1e2120;
  color: #ffffff;
  border: none;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  line-height: 44px;
  font-size: 16px;
  letter-spacing: 0.05em;
  cursor: pointer;
}
.opcion-menu-escritorio:hover {
  text-decoration: underline;
}

@media all and (max-width: 767px) {
  .boton-abre-menu {
    border-style: none;
    display: block;
  }
  .logo-embajadores {
    cursor: pointer;
    height: 65px;
    width: 140px;
    margin-left: 30px;
  }
  .menu-escritorio {
    display: none;
  }
  .nav-masters {
    justify-content: center;
    grid-template-columns: repeat(1, 1fr);
  }
  .nav-masters__usuario {
    display: none;
  }
  .nav-masters__offset {
    display: none;
  }
}
</style>
